module.exports = __webpack_public_path__ + "img/semas_ci.d72661e6.png";